import { IPrivateEndpointMetadata } from './private-endpoint-metadata';
import { getStorageAccountControls, getReadonlyControl, storageResourceIdFormat, storageResourceIdErrorMessage } from './shared-control-metadata';

import { adfModelTypeMap } from '../consts/adf-model-type-map-const';

export const azureStoragePrivateEndpointMetadata: IPrivateEndpointMetadata = {
    resourceType: 'Microsoft.Storage/storageAccounts',
    connectionSuffix: 'networking',
    resourceIdValidator: storageResourceIdFormat,
    groupIdMetadata: {
        blob: {
            linkedServiceType: adfModelTypeMap.azureBlob.linkedServiceType,
            groupId: 'blob',
            iconClass: 'svg-i-100x100-AzureBlob',
            displayName: stringResources.AzureBlobStorage_DisplayText,
            controls: {
                creationControls: getStorageAccountControls(false, 'blob'),
                readonlyControls: getReadonlyControl(storageResourceIdFormat, storageResourceIdErrorMessage)
            }
        },
        dfs: {
            linkedServiceType: adfModelTypeMap.azureBlobFS.linkedServiceType,
            groupId: 'dfs',
            iconClass: 'svg-i-100x100-AzureBlob',
            displayName: stringResources.AzureBlobFS_DisplayText,
            customDefaultNamePrefix: 'AzureDataLakeStorage',
            controls: {
                creationControls: getStorageAccountControls(true, 'dfs'),
                readonlyControls: getReadonlyControl(storageResourceIdFormat, storageResourceIdErrorMessage)
            }
        },
        queue: {
            linkedServiceType: adfModelTypeMap.azureQueue.linkedServiceType,
            groupId: 'queue',
            iconClass: 'svg-i-100x100-AzureBlob',
            displayName: stringResources.AzureQueue_DisplayText,
            controls: {
                creationControls: getStorageAccountControls(false, 'queue'),
                readonlyControls: getReadonlyControl(storageResourceIdFormat, storageResourceIdErrorMessage)
            }
        },
        file: {
            linkedServiceType: adfModelTypeMap.azureFileStorage.linkedServiceType,
            groupId: 'file',
            iconClass: 'svg-i-100x100-AzureFileStorage',
            displayName: stringResources.AzureFileStorage_DisplayText,
            controls: {
                creationControls: getStorageAccountControls(false, 'file'),
                readonlyControls: getReadonlyControl(storageResourceIdFormat, storageResourceIdErrorMessage)
            }
        },
        table: {
            linkedServiceType: adfModelTypeMap.azureTable.linkedServiceType,
            groupId: 'table',
            iconClass: 'svg-i-100x100-AzureTable',
            displayName: stringResources.AzureTableStorage_DisplayText,
            controls: {
                creationControls: getStorageAccountControls(false, 'table'),
                readonlyControls: getReadonlyControl(storageResourceIdFormat, storageResourceIdErrorMessage)
            }
        }
    }
};
